import React from 'react'
import About_1 from '../../../assets/images/home_page_7/about/01.png'

const About = () => {
    return (
        <>
            <section id="about" className="about-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-5">
                            <div className="section">
                                <h2 className="section-heading">
                                    Sustainable Agriculture and Environmental
                                </h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry Loreaim Ipsum has been the industry's standard dummyLorem
                                    Ipsum is an oi simply dummy text of the printing and typ
                                </p>
                                <ul className="about-lst">
                                    <li>
                                        <i className="flaticon-check" />
                                        Mistakes To Avoid to the dummy printing has bees ind.
                                    </li>
                                    <li>
                                        <i className="flaticon-check" />
                                        Your Startup industry standard loream saum.
                                    </li>
                                    <li>
                                        <i className="flaticon-check" />
                                        Knew About Fonts text the printing and something do.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 offset-lg-1 col-md-6 offset-md-1">
                            <div className="about-img text-end">
                                <img
                                    src={About_1}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default About
